import React from 'react'
import { Empty } from 'antd'
import { useTranslation } from 'react-i18next'
import ClientCard from './ClientCard'
import SearchInput from './SearchInput'
import { ClientCardSkeleton } from './AdLibrarySkeletons'
import useDragScroll from '../hooks/useDragScroll'
import ClientsSectionHolder from '../styles/clientsSectionStyle'

// `onSearch` receives the debounced term (SearchInput owns the input + debounce);
// the parent uses it as the server-side `search` param to refetch clients.
const ClientsSection = ({ clients = [], loading = false, onSearch, selectedClient, onSelectClient }) => {
  const { t } = useTranslation()
  const listRef = useDragScroll()

  return (
    <ClientsSectionHolder>
      <div className="section-header">
        <h2>{t('Clients')}</h2>
        <SearchInput placeholder={t('Search')} onSearch={onSearch} />
      </div>

      {!loading && clients.length === 0 ? (
        <Empty
          // Sized to roughly match a row of client cards so the layout doesn't collapse.
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 82, margin: 0 }}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={t('No clients available')}
        />
      ) : (
        <div className="clients-list" ref={listRef}>
          {loading
            ? Array.from({ length: 5 }).map((_, i) => <ClientCardSkeleton key={i} />)
            : clients.map((client) => (
                <ClientCard
                  key={client.id}
                  client={client}
                  selected={selectedClient && selectedClient.id === client.id}
                  onClick={() => onSelectClient(client)}
                />
              ))}
        </div>
      )}
    </ClientsSectionHolder>
  )
}

export default ClientsSection
